<template>
  <div class="top-0 right-0 left-0 bg-white">
    <div class="px-20 py-32 flex justify-between items-baseline text-16" v-on="triggers">
      {{ filter.text }}
      <i class="fal text-dark-gray" :class="[isOpen ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
    </div>
    <div v-show="isOpen" class="px-20 pb-26 h-full">
        <div v-for="option in filter.options" class="flex items-center mb-6">
          <filter-checkbox
            :input="query[option.filter]"
            @input="queryActions.sync({[option.filter]: $event, page: 1})"
            :value="option.value">
            {{ option.text }}
          </filter-checkbox>
        </div>
      </div>
  </div>
</template>

<script>
import FilterCheckbox from './FilterCheckbox'
import CustomDisclosure from './CustomDisclosure'

export default {
  extends: CustomDisclosure,

  data () {
    return {
      isOpen: true,
      hasFilters: false,
    }
  },

  props: {
    filter: {
      type: Object,
      required: true,
    },
  },

  inject: ['query', 'queryActions'],

  components: {
    FilterCheckbox,
  },
}
</script>

<style>
  .filterMobileBorder:last-child {
    border-bottom: 1px solid #E5E0DF;
  }
</style>